// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"8c21d2e4","266":"3168426f","345":"6be2ca7a","412":"d82fef36","763":"7290f379","813":"8c21d2e4"}[chunkId] + ".chunk.js";
};